import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown, ExternalLink, LogIn } from "lucide-react";
import { PORTALS } from "@/lib/portals";

export const PortalLink = ({ p, testid, onClick }) => (
  <a href={p.url} target="_blank" rel="noopener noreferrer" onClick={onClick} data-testid={testid}
    className="group flex items-start gap-3 rounded-2xl p-3 transition-colors duration-200 hover:bg-[#EAF3FF]">
    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-[#0B2A6F] font-display text-sm font-extrabold text-lime-300">{p.name[0]}</span>
    <span className="min-w-0 flex-1">
      <span className="flex items-center gap-1.5 font-display text-base font-extrabold text-[#050B1F]">
        {p.name} <ExternalLink className="h-3.5 w-3.5 text-emerald-600 opacity-0 transition-opacity group-hover:opacity-100" />
      </span>
      <span className="block text-xs text-slate-600">{p.desc}</span>
    </span>
  </a>
);

export const SignInMenu = ({ variant = "light", testid = "signin-menu-btn" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const btn = variant === "dark"
    ? "text-white/90 hover:text-lime-300"
    : "border border-[#0B2A6F]/20 text-[#0B2A6F] hover:border-[#0B2A6F] hover:bg-[#0B2A6F] hover:text-white";

  return (
    <div ref={ref} className="relative">
      <button data-testid={testid} onClick={() => setOpen((v) => !v)} aria-expanded={open}
        className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-bold transition-colors duration-300 ${btn}`}>
        <LogIn className="h-4 w-4" /> Sign In
        <ChevronDown className={`h-4 w-4 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: 8, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 8, scale: 0.97 }}
            transition={{ duration: 0.2 }} data-testid="signin-dropdown"
            className="absolute right-0 top-full z-[60] mt-3 w-80 origin-top-right rounded-3xl border border-[#0B2A6F]/10 bg-white p-3 shadow-[0_30px_80px_-20px_rgba(5,11,31,0.45)]">
            <p className="px-3 pb-2 pt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-600">Merchant portals</p>
            {PORTALS.map((p) => <PortalLink key={p.id} p={p} testid={`signin-${p.id}-link`} onClick={() => setOpen(false)} />)}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
